import Vue from 'vue';
import Router from 'vue-router';

import CreateTopic from './views/management/CreateTopic.vue';

import Edit from './views/management/Edit';
import General from './views/management/edit/General';
import Data from './views/management/edit/Data';
import Members from './views/management/edit/Members';
import Integrations from './views/management/edit/Integrations';

import Topics from './views/management/Topics';
import Topic from './views/management/Topic';
import Management from './views/management/Management.vue';

import Labelling from './components/labelling/Labelling';
import Home from './views/labelling/Home.vue';
import Board from './views/labelling/Board.vue';
import Search from './views/labelling/Search.vue';

import NotFound from './components/NotFound.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Labelling,
      children: [
        {
          path: '',
          name: 'Home',
          component: Home
        },
        {
          path: 'search',
          name: 'Search',
          component: Search
        }
      ]
    },
    {
      path: '/labelling/:id',
      name: 'Labelling Board',
      component: Board
    },
    {
      path: '/topics',
      component: Management,
      children: [
        {
          path: '',
          name: 'Topics',
          component: Topics
        },
        {
          path: 'create',
          name: 'Create Topic',
          component: CreateTopic
        },
        {
          path: ':id/',
          name: 'Topic',
          component: Topic
        },
        {
          path: ':id/edit',
          component: Edit,
          children: [
            {
              path: '',
              name: 'Edit Topic',
              component: General
            },
            {
              path: 'data',
              name: 'Manage Topic Data',
              component: Data
            },
            {
              path: 'members',
              name: 'Manage Topic Members',
              component: Members
            },
            {
              path: 'integrations',
              name: 'Manage Integrations',
              component: Integrations
            }
          ]
        }
      ]
    },
    { path: '*', component: NotFound }
  ]
});
